import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import { formatNotificationTime } from "libs/context/NotificationContext";

const formatNotificationTimeLabel = (item = {}) => {
  const relative = String(item?.createdOnRelative ?? item?.timeLabel ?? "").trim();
  if (relative) return relative.toUpperCase();
  const formatted = formatNotificationTime(item?.createdOn ?? item?.createdAt);
  return String(formatted || "JUST NOW").toUpperCase();
};

const SimpleNotificationListItem = ({
  item = {},
  compact = false,
  onClick,
}) => {
  const unread = Boolean(item?.unread ?? !item?.read);
  const company = String(
    item?.company ?? item?.clientName ?? item?.title ?? ""
  ).trim();
  const action = String(item?.action ?? "").trim();
  const user = String(
    item?.user ??
      item?.candidateName ??
      item?.candidateDisplayName ??
      item?.userName ??
      ""
  ).trim();
  const message = String(item?.message ?? "").trim();
  const messageIsHtml = Boolean(item?.messageIsHtml);
  const hasStructuredCopy = !messageIsHtml && Boolean(company || action || user);
  const timeLabel = formatNotificationTimeLabel(item);

  const renderMessageBody = () => {
    if (hasStructuredCopy) {
      return (
        <>
          {company ? <span className="simple-notification-feed-item__emphasis">{company}</span> : null}
          {company && (action || user) ? " " : null}
          {action ? (
            <span className="simple-notification-feed-item__muted">{action}</span>
          ) : null}
          {action && user ? " " : null}
          {user ? <span className="simple-notification-feed-item__emphasis">{user}</span> : null}
        </>
      );
    }

    const htmlContent = message || "Notification";
    return (
      <span
        className="simple-notification-feed-item__emphasis simple-notification-feed-item__message-html common-candidate-table-html-dangerous"
        dangerouslySetInnerHTML={{ __html: htmlContent }}
      />
    );
  };

  return (
    <div
      className={classnames("simple-notification-feed-item", {
        "simple-notification-feed-item--compact": compact,
        "simple-notification-feed-item--unread": unread,
        "simple-notification-feed-item--clickable": Boolean(onClick),
      })}
      onClick={() => onClick?.(item)}
      role={onClick ? "button" : undefined}
      tabIndex={onClick ? 0 : undefined}
      onKeyDown={(event) => {
        if (!onClick) return;
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          onClick(item);
        }
      }}
    >
      <div className="simple-notification-feed-item__icon-wrap">
        <div
          className={classnames(
            "simple-notification-feed-item__icon rounded-circle d-flex align-items-center justify-content-center",
            unread ? "simple-notification-feed-item__icon--unread" : "simple-notification-feed-item__icon--read"
          )}
        >
          <i className="fa fa-bell text-white" aria-hidden />
        </div>
      </div>

      <div className="simple-notification-feed-item__content flex-grow-1">
        <div className="simple-notification-feed-item__message fw-normal">
          {renderMessageBody()}
        </div>

        <div className="simple-notification-feed-item__time text-muted mt-1 d-flex align-items-center">
          <i className="fa fa-clock me-2" aria-hidden />
          <small>{timeLabel}</small>
        </div>
      </div>
    </div>
  );
};

SimpleNotificationListItem.propTypes = {
  item: PropTypes.object,
  compact: PropTypes.bool,
  onClick: PropTypes.func,
};

export default SimpleNotificationListItem;
